import React from 'react'
import { DefaultRootState, connect, useDispatch, useSelector } from 'react-redux'
import { reduxForm, getFormValues, submit as formSubmit } from 'redux-form'
import styled from 'styled-components'
import flowRight from 'lodash/flowRight'
import get from 'lodash/get'
import transformProps from 'loankeeper-common/containers/transformProps'
//@ts-ignore
import { PlainTextContainer } from 'shared/StyledComponents'
//@ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
//@ts-ignore
import DropdownField from 'shared/FormFields/DropdownField'
//@ts-ignore
import PlainTextField from 'shared/FormFields/PlainTextField'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKModal, { actions as LKModalActions, LKModalContainer } from 'shared/LKModal'
import { sendSMS } from 'src/store/client'

import { smsSendTranslate } from '../helpers'

import { SendSMSModalProps } from '../types'
const StyledFormField = styled(FormField)`
  &.lk-textarea {
    height: 330px;
  }
`

export const SMSModalName = 'clientDetailsSendSMSModal'
export const SMSModalFormName = 'clientDetailsSendSMSModalForm'
export const sendSMSFetcherName = 'clientDetailsSendSMSFetcher'
export const smsMaxLength = 160
export const phoneLength = 9

const getSmsTextRemainingLength = (state: DefaultRootState) => {
  const currentSMSLength = get(getFormValues(SMSModalFormName)(state), 'smsText.length', 0)
  return smsMaxLength - currentSMSLength
}

const getSendSMSButtonDisability = (state: DefaultRootState) =>
  get(getFormValues(SMSModalFormName)(state), 'smsText.length', 0) === 0

const isPhone = (phone: string) => !!phone

const isPhoneProper = (phone: string) => {
  if (!isPhone(phone)) {
    return false
  }
  return phone.length === phoneLength
}

const SendSMSForm = flowRight(
  transformProps(({ cellPhone, phone, ...restProps }) => {
    let options = [{ value: cellPhone }]
    if (isPhoneProper(phone)) {
      options = [...options, { value: phone }]
    }
    return { ...restProps, options }
  }),
  transformProps((props) => {
    const { options } = props
    const hasPhoneChoices = options.length > 1
    return { ...props, hasPhoneChoices }
  }),
  //@ts-ignore
  connect((_state, { options }) => ({
    initialValues: { phoneNumber: options[0].value, smsText: '' },
  })),
  reduxForm({
    form: SMSModalFormName,
    onSubmit: async ({ smsText, phoneNumber }, dispatch, { ID, hash, fetchPage }) => {
      dispatch(LKModalActions.close(SMSModalName))
      // dispatch(
      //   fetchSFM({
      //     instanceName: sendSMSFetcherName,
      //     callApi: Client.sendSMS,
      //     callApiArgs: [ID, hash, smsText, phoneNumber],
      //     resolve: () => fetchPage(),
      //     reject: (error) => {
      //       dispatch(LKModalActions.openError(smsSendTranslate(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST client_oper_api page: smssend
      try {
        const res = await dispatch(
          sendSMS({
            ID,
            hash,
            smsText,
            phoneNumber,
          }),
        )
        if (sendSMS.fulfilled.match(res)) {
          fetchPage()
        } else if (sendSMS.rejected.match(res)) {
          dispatch(LKModalActions.openError(smsSendTranslate(res.error.message)))
        }
      } catch (error) {
        dispatch(LKModalActions.openError(smsSendTranslate(error?.Error?.Message || error?.Error?.Text)))
      }
    },
  }),
)((props: SendSMSModalProps) => {
  const { client, hasPhoneChoices, options } = props
  const smsTextRemainingLength = useSelector((state) => getSmsTextRemainingLength(state))
  return (
    <form>
      <FormLayout label={smsSendTranslate('lbl_client')}>
        <PlainTextContainer>{client}</PlainTextContainer>
      </FormLayout>

      <FormLayout fieldProportions="12:4" label={smsSendTranslate('lbl_cellphone')}>
        {hasPhoneChoices ? (
          <DropdownField name="phoneNumber" options={options} />
        ) : (
          <PlainTextField name="phoneNumber" />
        )}

        <PlainTextContainer>{smsTextRemainingLength}</PlainTextContainer>
      </FormLayout>

      <StyledFormField className="u-marginTop-5" type="textarea" name="smsText" />
    </form>
  )
})

const SendSMSModal = ({ modalInstanceName, ...rest }) => {
  const dispatch = useDispatch()

  const sendSMSButtonDisability = useSelector(getSendSMSButtonDisability)

  function handleSubmit() {
    dispatch(formSubmit(SMSModalFormName))
  }

  return (
    <LKModal
      icon="sms"
      name={modalInstanceName}
      heading={smsSendTranslate('frm_sms_send')}
      size="sm-1"
      footer={
        <LKModal.Footer>
          <LKButton alias="sms" onClick={handleSubmit} disabled={sendSMSButtonDisability}>
            {smsSendTranslate('cmd_send_queue')}
          </LKButton>
        </LKModal.Footer>
      }
    >
      <SendSMSForm
        {...rest}
        name={modalInstanceName}
        close={() => dispatch(LKModalActions.close(SMSModalName))}
        submit={handleSubmit}
      />
    </LKModal>
  )
}

export default LKModalContainer(SMSModalName)(SendSMSModal)
